import script from "./PortalBonusCampaignPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalBonusCampaignPage.vue?vue&type=script&setup=true&lang=js"

import "./PortalBonusCampaignPage.vue?vue&type=style&index=0&id=4cb1798a&lang=scss"
import "./PortalBonusCampaignPage.vue?vue&type=style&index=1&id=4cb1798a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb1798a"]])

export default __exports__